import * as constants from '../common.components.constants';

export function setCopiedValue(value) {
  return {
    type: constants.SET_MENTION_COMPONENT_COPIED_VALUE,
    value
  };
}
